module.exports = __webpack_public_path__ + "img/pizzavert_on.0834bdcd.gif";